import { Button } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined, MenuOutlined } from '@ant-design/icons';

/** Header 左側按鈕：手機開啟抽屜選單（56px 觸控區），桌機收折側欄。 */
export default function NavToggle({ isMobile, collapsed, onClick }: { isMobile: boolean; collapsed: boolean; onClick: () => void }) {
  if (isMobile) {
    return (
      <Button
        type="text"
        aria-label="開啟選單"
        className="!h-14 !w-14 shrink-0 !rounded-none text-gray-600 hover:!bg-gray-100"
        icon={<MenuOutlined />}
        onClick={onClick}
      />
    );
  }
  return (
    <Button
      type="text"
      aria-label="收折側欄"
      className="!h-16 !w-16 !rounded-none text-gray-500 hover:!bg-gray-100"
      icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
      onClick={onClick}
    />
  );
}
